module.exports = __webpack_public_path__ + "static/eficode-9419e9ec58883c869b5b7b8a41ac4d7c.svg";